/*
	Dependencies
		- jquery
		- plugintooltip
*/
(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    /* istanbul ignore else  */
    define('header.cartReminder', ['jquery', 'plugin.tooltip', 'thd-customer', 'cookie-utils', 'header.analytics'], (jQuery, plugintooltip, thdCustomer, cookieUtils, headerAnalytics) =>
      factory(jQuery, plugintooltip, thdCustomer, cookieUtils, headerAnalytics));
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.cartReminder = factory(jQuery, plugintooltip, thdCustomer, cookieUtils, headerAnalytics);
    /* eslint-enable */
  }
}(this, ($, plugintooltip, thdCustomer, cookieUtils, headerAnalytics) => {

  let preButton, nexButton, cartReminderImageContainer;
  const cartReminder = {};
  var privateMethods = { TooltipTimeoutTime: 10000 };
  var carouselPositions = [];
  let carouselItemsLength;
  let currentItem;
  var lastScrollAt = Date.now()
    , timeout;
  let TooltipTimeout;
  let carouselItemWidth = 0;
  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  let cartReminderElement;

  const carouselElementTemplate = `
    <div class="cartReminderImages">
      <a href="https://www.homedepot.com/p/{itemId}">
       <img class="slide-image" src="https://images.homedepot-static.com/productImages/{image}/svn/i_100.jpg"
       onerror='this.onerror=null;this.src="https://assets.homedepot-static.com/images/v1/no-img-micro.svg"' />
      </a>
    </div>
  `
  thdCustomer = thdCustomer.default || thdCustomer;

  function setupCartItems() {

    privateMethods.items = [];

    let items = cookieUtils.readBrowserCookie('cr_details');

    if (items) {
      try {
        items = JSON.parse(items);
        privateMethods.items = items;
      }
      catch (e) {
        // error in json parsing cookie
      }
    }

  }

  function shouldShowReminder() {

    if (window && window.location && window.location.href &&
      window.location.href.toLowerCase().includes('mycart')) {
      return false;
    }

    const { isB2CCustomer } = thdCustomer;

    if (isB2CCustomer === false) {
      return false;
    }

    if (cookieUtils.readBrowserCookie('cr_timer')) {
      return false;
    }

    setupCartItems();
    return (privateMethods.items.length);

  }

  function updateWelcomeMessage() {

    const { isLoggedIn, isPersisted } = thdCustomer;

    // only grab usersName when it's in logged in or persisted log in state
    privateMethods.usersName = (isLoggedIn || isPersisted) ? cookieUtils.getTHDUserName() : undefined;

    if (privateMethods.usersName) {
      $('#welcome-text').html(`
        Welcome back,
        <div>
          ${privateMethods.usersName}!
        </div>
      `);
    }
  }

  cartReminder.init = function init() {

    if (shouldShowReminder()) {

      updateWelcomeMessage();

      cartReminderImageContainer = $('#cartReminderImageContainer');
      cartReminderElement = $('#cartReminder');
      let CartReminderToolTipContent = $('#CartReminderToolTipContent');
      cartReminderElement.tooltip({
        type: 'click',
        noPad: true,
        closeOnClick: true,
        width: 'small',
        onOpen: function _onOpenTooltip($tooltip, complete) {
          CartReminderToolTipContent
            .removeClass('u--hide')
            .appendTo($tooltip);
          initCarousel();
          cookieUtils.setCookieExpireInSeconds('cr_timer', '1', (48 * 60 * 60), '.homedepot.com');
          headerAnalytics.cartReminder();
          complete();
        },
        closeButton: false
      });

      cartReminderElement.tooltip('open');
      TooltipTimeout = setTimeout(() => { cartReminderElement.tooltip('close'); }, privateMethods.TooltipTimeoutTime);
      CartReminderToolTipContent.one('touchstart click', () => {
        if (TooltipTimeout) {
          clearTimeout(TooltipTimeout);
        }
      });

    }
    return this;
  };

  cartReminder.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  function initCarousel() {

    let imageElementsDiv = '';

    for (let i = 0, l = privateMethods.items.length; i < l; i++) {
      imageElementsDiv = imageElementsDiv + carouselElementTemplate.replace('{itemId}', privateMethods.items[i][0])
        .replace('{image}', privateMethods.items[i][1]);
    }

    cartReminderImageContainer.html(imageElementsDiv);

    let imageElements = $('.cartReminderImages');

    carouselItemsLength = imageElements.length;
    carouselItemWidth = imageElements[0] ? imageElements[0].offsetWidth : 0;

    for (let index = 0; index < carouselItemsLength; index++) {
      carouselPositions.push(carouselItemWidth * index);
    }
    preButton = $('.preButton').closest('.cartReminder__carouselButtonContainer');
    nexButton = $('.nexButton').closest('.cartReminder__carouselButtonContainer');
    if (carouselItemsLength > 1) {
      preButton.css('visibility', 'hidden');

      preButton.click((e) => {
        scrollImage('previous');
      });

      nexButton.click((e) => {
        scrollImage('next');
      });

    } else {

      preButton.addClass('u--hide');
      nexButton.addClass('u--hide');
      cartReminderImageContainer.css('width', '300');
    }

    cartReminderImageContainer.on("scroll", function () {
      lastScrollAt = Date.now()
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        if (Date.now() - lastScrollAt > 99)
          updateCarouselArrows();
      }, 100);
    });
    $('.cartReminder__closebutton').click(function () {
      if (cartReminderElement) {
        cartReminderElement.tooltip('close');
      }
    });
  }
  function updateCarouselArrows() {
    currentItem = undefined;
    let currentScrollLeft = cartReminderImageContainer.scrollLeft();
    carouselPositions.find(
      function (e, i) {
        if (e === currentScrollLeft) {
          currentItem = i;
          return true;
        }
        return false;
      }
    );
    if (currentItem === carouselItemsLength - 1) {
      nexButton.css('visibility', 'hidden');
      preButton.css('visibility', 'visible');
    } else if (currentItem === 0) {
      preButton.css('visibility', 'hidden');
      nexButton.css('visibility', 'visible');
    } else {
      preButton.css('visibility', 'visible');
      nexButton.css('visibility', 'visible');
    }
  }
  function scrollImage(direction) {
    updateCarouselArrows();
    if (currentItem === undefined) return;
    if (direction === 'next') {
      if (currentItem === carouselItemsLength - 1) return;
      currentItem++;
    } else if (direction === 'previous') {
      if (currentItem === 0) return;
      currentItem--;
    }
    if (isSafari) {
      cartReminderImageContainer.stop().animate({ scrollLeft: carouselPositions[currentItem] }, 500, 'swing');
    } else {
      cartReminderImageContainer[0].scrollTo({
        left: carouselPositions[currentItem],
        behavior: 'smooth'
      });
    }
  }


  return cartReminder;
}));
